import React from 'react';
import { ExpiredSession } from '../expired-session';
import { ExternalError } from '../external-error';
import './style.scss';

interface IProps {
  expiredSession: boolean;
  isExternalError: boolean;
  isFromCondo?: boolean;
  isSavingsMismatch?: boolean;
}

export class Notification extends React.Component<IProps, null> {
  render(): React.ReactNode {
    const { expiredSession, isExternalError, isFromCondo = false, isSavingsMismatch } = this.props;

    return (
      <div className="notification-wrapper">
        {expiredSession && (
          <ExpiredSession isFromCondo={isFromCondo} isSavingsMismatch={isSavingsMismatch} />
        )}
        {isExternalError && <ExternalError isFromCondo={isFromCondo} />}
      </div>
    );
  }
}
